/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbSharedRelatedItems_itemSearch = {
    readonly relatedItems: {
        readonly edges: ReadonlyArray<{
            readonly node: {
                readonly serviceId: string | null;
                readonly " $fragmentRefs": FragmentRefs<"SharedItemTile_item">;
            } | null;
        } | null> | null;
    } | null;
    readonly " $refType": "SbSharedRelatedItems_itemSearch";
};
export type SbSharedRelatedItems_itemSearch$data = SbSharedRelatedItems_itemSearch;
export type SbSharedRelatedItems_itemSearch$key = {
    readonly " $data"?: SbSharedRelatedItems_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRelatedItems_itemSearch">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbSharedRelatedItems_itemSearch",
  "type": "ItemSearchQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": "relatedItems",
      "name": "thinBrowseRelatedItems",
      "storageKey": "thinBrowseRelatedItems(first:12,seller:\"INCLUDE\")",
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 12
        },
        {
          "kind": "Literal",
          "name": "seller",
          "value": "INCLUDE"
        }
      ],
      "concreteType": "itemSearchMoreLikeThisConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "itemSearchMoreLikeThisEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "Item",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "serviceId",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "FragmentSpread",
                  "name": "SharedItemTile_item",
                  "args": null
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = 'f301a3bc9e68e5e257bd682fc64b6585';
export default node;
